module.exports = "/images/datepicker-next.png?fc3608fe1c181fa1a52bbc296036b5ef";